
import React from 'react'
import Icon2 from '../../Icon2'
import Textarea from '../../Textarea/Textarea'
import Paragraph from '../../Typography/Paragraph/Paragraph'
import Button from '../../Button/Button'
import Field from '../../Field/Field'
import { TranslationButton, TranslationPopoverProps, DetectionItem } from '../helper'
import { useFormikContext } from 'formik'

interface TextAreaItem {
    text?: string;
}

interface TextAreaFieldConfig {
    uid: string;
    title?: string;
    type?: string;
    locked?: boolean;
    enable_translation?: boolean;
    TranslationPopover?: (props: TranslationPopoverProps) => React.JSX.Element;
    translationLabel?: string;
}

type UpdateValueFunction = (event: {
    target: {
        value: DetectionItem[];
        type: string;
        name: string;
    };
}) => void;

type ListTextAreaProps = {
    field: TextAreaFieldConfig;
    item: TextAreaItem;
    updateValue: UpdateValueFunction;
    isTranslated?: boolean;
    setIsTranslated?: (isTranslated: boolean) => void;
}

const ListTextArea = ({ field, item, updateValue, isTranslated, setIsTranslated }: ListTextAreaProps) => {
    const { initialValues } = useFormikContext();

    const handleCopyText = (text: string) => {
        return async () => {
            try {
                await navigator.clipboard.writeText(text)
            } catch (error) {
                console.error('Failed to copy text: ', error)
            }
        }
    }

    return (
        <div className='Sidebar__text-area__container'>
            <div className='Sidebar__text-area__title-container'>
                <Paragraph text={field.title} variant='p3' variantStyle='bold' className='Sidebar__text-area__title' />
            </div>
            <Field>
                <div className='Sidebar__text-area__item'>
                    <Textarea
                        value={item.text}
                        version='v2'
                        width='full'
                        className={`Sidebar__text-area ${!field.locked ? 'Sidebar__text-area__unlocked' : ''}`}
                        suffix={field.locked ? <Icon2 icon='LockBlack' className='Sidebar__text-area__suffix' /> : null}
                        isReadOnly={field.locked ? true : false}
                    />
                    <Button
                        size='small'
                        text=''
                        buttonType='tertiary'
                        version='v2'
                        icon={`v2-Copy`}
                        className='Sidebar__text-area__edit-button'
                        onClick={handleCopyText(item.text)}
                    />
                </div>
            </Field>
            {field.enable_translation &&
                <TranslationButton
                    translationLabel={field.translationLabel || `Translate to Spanish-Spain`}
                    TranslationPopover={field.TranslationPopover}
                    updateValue={updateValue}
                    masterLanguage={initialValues[field.uid]}
                    uid={field.uid}
                    isTranslated={isTranslated}
                    setIsTranslated={setIsTranslated}
                />
            }
        </div>
    )
}

export default ListTextArea